/**
 * Global analytics facade for gtag / dataLayer.
 *
 * Usage:
 *   FmAnalytics.track('event_name', { key: 'value' });
 *
 * Declarative clicks — put all params on the trigger node:
 *   <a data-fm-track="banner_item_click"
 *      data-fm-banner-index="0"
 *      data-fm-banner-link="/collections/all"
 *      data-fm-section-index="1">...</a>
 *
 * Mapping: data-fm-{param} → GA4 event param {param}
 *   data-fm-banner-index → banner_index
 *   data-fm-section-index → section_index
 * page_type is injected automatically from themeVariables.
 */
(function () {
  'use strict';

  if (window.FmAnalytics) return;

  var TRACK_ATTR = 'data-fm-track';
  var PARAM_PREFIX = 'fm';
  var RESERVED_KEYS = { track: true };

  function getPageType() {
    try {
      return (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType) || '';
    } catch (e) {
      return '';
    }
  }

  function coerceValue(value) {
    if (value === '' || value == null) return value;
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (/^-?\d+$/.test(value)) return Number(value);
    if (/^-?\d+\.\d+$/.test(value)) return Number(value);
    return value;
  }

  /**
   * Collect every data-fm-* on the trigger element (except data-fm-track).
   * data-fm-banner-index → banner_index
   */
  function collectDatasetParams(element) {
    var params = {};
    if (!element || !element.dataset) return params;

    Object.keys(element.dataset).forEach(function (key) {
      if (key.indexOf(PARAM_PREFIX) !== 0) return;
      var paramKey = key.slice(PARAM_PREFIX.length);
      if (!paramKey) return;

      paramKey = paramKey.charAt(0).toLowerCase() + paramKey.slice(1);
      paramKey = paramKey.replace(/[A-Z]/g, function (match) {
        return '_' + match.toLowerCase();
      });

      if (RESERVED_KEYS[paramKey]) return;
      params[paramKey] = coerceValue(element.dataset[key]);
    });

    return params;
  }

  function send(eventName, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, params));
  }

  function track(eventName, payload) {
    if (!eventName) return;

    var params = Object.assign(
      { page_type: getPageType() },
      payload || {}
    );

    console.log('[FmAnalytics]', eventName, params);
    send(eventName, params);
  }

  function findTrackElement(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (node && node.nodeType === 1 && node.getAttribute && node.getAttribute(TRACK_ATTR)) {
        return node;
      }
    }

    var target = event.target;
    if (target && target.nodeType === 3) target = target.parentElement;
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest('[' + TRACK_ATTR + ']');
  }

  function onDelegatedClick(event) {
    var trackEl = findTrackElement(event);
    if (!trackEl) return;

    var eventName = trackEl.getAttribute(TRACK_ATTR);
    if (!eventName) return;

    track(eventName, collectDatasetParams(trackEl));
  }

  document.addEventListener('click', onDelegatedClick, true);

  window.FmAnalytics = {
    track: track,
  };
})();
